import { PublicLayout } from "@/components/layout/PublicLayout";

const AGB = () => {
  return (
    <PublicLayout
      showHero={true}
      heroTitle="AGB"
      heroSubtitle="Allgemeine Geschäftsbedingungen"
      heroVariant="compact"
    >
      <div className="container mx-auto px-4 py-16">
        <div className="prose max-w-4xl mx-auto">
          <h1 className="text-3xl font-bold mb-8">Allgemeine Geschäftsbedingungen (AGB)</h1>

          <p className="mb-6">Der Verkauf und die Zahlungsabwicklung unserer Produkte erfolgen in der Regel über Digistore24 GmbH.</p>

          <p className="mb-6">In diesen Fällen ist der Vertragspartner der Käufer ausschließlich die Digistore24 GmbH.</p>

          <p className="mb-8">Es gelten die Allgemeinen Geschäftsbedingungen von Digistore24, abrufbar unter:</p>
          
          <div className="bg-gray-50 p-6 rounded-lg border-l-4 border-blue-500">
            <a 
              href="https://www.digistore24.com/page/terms" 
              className="text-blue-600 hover:text-blue-800 font-medium"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://www.digistore24.com/page/terms
            </a>
          </div>
        </div>
      </div>
    </PublicLayout>
  );
};

export default AGB;